import styled from 'styled-components';

const ViewAllClients = styled.div`
  justify-content: right;

  display: grid;
  grid-template-columns: 1fr 100px;

  .text {
    width: 100%;
    text-align: right;
    padding-right: 20px;
    padding-top: 6px;
  }
`;

export { ViewAllClients };
